import React, { useMemo } from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';
import { Motif } from '~/cards/components/CardListing/types';

import { FilterOption } from './Menu.style';

interface MotifMenuProps {
  optionList: Motif[];
  activeValue: string[];
  updateFilter: (filter: 'motifs', value: string[]) => void;
}

export const MotifMenu: React.FC<MotifMenuProps> = ({ optionList, activeValue, updateFilter }) => {
  const sortedMotifs = useMemo(
    () => optionList?.sort((a, b) => a.display_order - b.display_order),
    [optionList]
  );

  if (!optionList) return null;

  return (
    <>
      {sortedMotifs.map((item) => (
        <FilterOption key={item.name}>
          <CheckboxField
            id={item.key.toLowerCase()}
            label={item.name}
            checked={activeValue?.includes(item.key.toUpperCase())}
            onChange={() => {
              const selected = item.key.toUpperCase();
              const newMotifs = activeValue.includes(selected)
                ? activeValue.filter((val) => val !== selected)
                : [...activeValue, selected];
              updateFilter('motifs', newMotifs);
            }}
            meta={{ touched: true }}
          />
        </FilterOption>
      ))}
    </>
  );
};
